import {
   MedicineAlcoholIndicatorConfig,
   MedicineId,
   MedicineSafetyIndicatorConfig,
   MedicineSafetyIndicatorType,
} from '../types';
import { useMedicineSafetyIndicatorsConfigMapGlobalState } from '../shared/useMedicineSafetyIndicatorsConfigMapGlobalState';

type UseMedicineSafetyIndicatorConfigOptions = {
   medicineId: MedicineId;
   indicatorType: MedicineSafetyIndicatorType;
};

type UseMedicineSafetyIndicatorConfigOutput = MedicineAlcoholIndicatorConfig | MedicineSafetyIndicatorConfig | null;

export const useMedicineSafetyIndicatorConfig = (
   options: UseMedicineSafetyIndicatorConfigOptions
): UseMedicineSafetyIndicatorConfigOutput => {
   const [globalState] = useMedicineSafetyIndicatorsConfigMapGlobalState();

   const medicineSafetyIndicatorConfig = globalState.get(options.medicineId);

   if (!medicineSafetyIndicatorConfig) {
      return null;
   }

   return medicineSafetyIndicatorConfig[options.indicatorType];
};
